import { API_BASE_URL, ENDPOINTS } from "../utils/constants";
import type { AddinConfigResponse } from "../types";

/**
 * Fetch add-in configuration for a user.
 * No authentication required — email-based lookup.
 */
export async function fetchAddinConfig(email: string): Promise<AddinConfigResponse> {
  // Use string concat — new URL(path, base) strips the /api prefix when path starts with "/"
  const url = new URL(`${API_BASE_URL}${ENDPOINTS.ADDIN_CONFIG}`);
  url.searchParams.set("email", email);
  url.searchParams.set("source", "outlook");

  const response = await fetch(url.toString(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 429) {
    throw new Error("Too many requests. Please try again in a moment.");
  }

  if (!response.ok) {
    const errorData = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(errorData.message || `Request failed: ${response.status}`);
  }

  return response.json() as Promise<AddinConfigResponse>;
}
